import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DashboardStatistics} from '../../entities/dashboard/dashboard-statistics.entity';
import {environment} from '../../../../environments/environment';
import {DashboardOnboarding} from '../../entities/dashboard/onboarding.entity';
import {SidebarNotifications} from '../../entities/dashboard/sidebar-notifications.entity';
import {PhotographerViewStatistics} from '../../entities/dashboard/view-stats.entity';

@Injectable({
  providedIn: 'root'
})
export class CreatorDashboardService
{
  public constructor(
    private readonly http: HttpClient
  ) {
  }

  public getStatistics(): Observable<DashboardStatistics> {
    return this.http.get<DashboardStatistics>(`${environment.apiUrl}/manage/creator/statistics`);
  }

  public getOnboarding(): Observable<DashboardOnboarding> {
    return this.http.get<DashboardOnboarding>(`${environment.apiUrl}/manage/creator/onboarding`);
  }

  public getNotifications(): Observable<SidebarNotifications> {
    return this.http.get<SidebarNotifications>(`${environment.apiUrl}/manage/creator/notifications`);
  }

  public getViewStatistics(): Observable<PhotographerViewStatistics> {
    return this.http.get<PhotographerViewStatistics>(`${environment.apiUrl}/manage/creator/statistics/views`);
  }

  public submitInstagramLink(profileUrl: string): Observable<void> {
    return this.http.post<void>(`${environment.apiUrl}/user/instagram`, { profileUrl });
  }
}
